import React, {Component} from 'react'
import {
  StyleSheet,
  View,
  Dimensions,
  ScrollView,
  ActivityIndicator,
  Alert,
} from 'react-native'
import {Text, Input, Button} from 'react-native-elements'
import {list} from './network'
import {Table, TableWrapper, Row, Cell} from 'react-native-table-component'

class List extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      tableHead: ['S.No', 'Title', 'Short code', 'Edit', 'Delete'],
      tableData: [],
    }
  }

  loadDataIntoTable = response => {
    let row = []
    response.forEach((video, index) => {
      const count = index + 1
      row.push([
        count,
        video.title.rendered,
        '[iv-player id=' + video.id + ']',
        video.id,
        video.id,
      ])
    })
    this.setState({
      tableData: row,
      isLoading: false,
    })
  }

  componentDidMount () {
    list()
      .then(response => {
        this.loadDataIntoTable(response)
      })
      .catch(error => {
        this.setState({
          isLoading: false,
        })
      })
  }

  render () {
    const state = this.state
    const elementEdit = (data, index) => (
      <Button
        buttonStyle={styles.buttonStyle}
        title={'EDIT'}
        titleStyle={styles.buttonTitleStyle}
        onPress={() => this.props.onUpdatePress(data)}
      />
    )
    const elementDelete = (data, index) => (
      <Button
        buttonStyle={styles.deleteButtonStyle}
        title={'DELETE'}
        titleStyle={styles.buttonTitleStyle}
        onPress={() => this.props.onDeletePress(data)}
      />
    )

    return this.state.isLoading ? (
      <ActivityIndicator />
    ) : (
      <View style={styles.container}>
        <Button
          buttonStyle={styles.addButtonStyle}
          title={'ADD NEW'}
          titleStyle={styles.buttonTitleStyle}
          onPress={this.props.onCreatePress}
        />
        {this.state.tableData != null && this.state.tableData.length > 0 ? (
          <Table borderStyle={{borderColor: 'transparent'}}>
            <Row
              data={state.tableHead}
              style={styles.headStyle}
              textStyle={styles.headingTextStyle}
            />
            {state.tableData.map((rowData, index) => (
              <TableWrapper key={index} style={styles.row}>
                {rowData.map((cellData, cellIndex) => (
                  <Cell
                    key={cellIndex}
                    data={
                      cellIndex === 3
                        ? elementEdit(cellData, index)
                        : cellIndex === 4
                        ? elementDelete(cellData, index)
                        : cellData
                    }
                    textStyle={styles.dataText}
                  />
                ))}
              </TableWrapper>
            ))}
          </Table>
        ) : (
          <View style={styles.noVideosViewStyle}>
            <Text style={styles.noVideoTextStyle}>
              Click <Text style={styles.addNewStyle}>ADD NEW</Text> button to
              add video to IV Player
            </Text>
          </View>
        )}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  noVideosViewStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 50,
  },
  noVideoTextStyle: {
    fontWeight: 'bold',
  },
  addNewStyle: {
    color: '#007599',
  },
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 10,
  },
  headStyle: {
    borderRadius: 10,
  },
  dataText: {margin: 10, color: 'black'},
  headingTextStyle: {
    color: '#007599',
    fontSize: 15,
    fontWeight: 'bold',
    margin: 6,
    color: '#007599',
  },
  row: {flexDirection: 'row', backgroundColor: '#ffffff'},
  buttonStyle: {
    width: 70,
    height: 30,
    backgroundColor: '#007599',
    borderRadius: 2,
  },
  deleteButtonStyle: {
    width: 70,
    height: 30,
    backgroundColor: 'red',
    borderRadius: 2,
  },
  buttonTitleStyle: {
    color: 'white',
    fontSize: 15,
  },
  addButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: '#007599',
    borderRadius: 2,
  },
})

export default List
